// extracted by mini-css-extract-plugin
module.exports = {"root":"by_bx"};